import { useState } from "react";
import { api, errorMsg } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Trash2 } from "lucide-react";

export const GestionCatalogosDialog = ({ tipo, onClose, categorias, onChanged }) => {
  const [nuevoCat, setNuevoCat] = useState("");

  const crearCategoria = async () => {
    try { await api.post("/categorias", { nombre: nuevoCat }); setNuevoCat(""); onChanged(); toast.success("Categoría creada"); }
    catch (e) { toast.error(errorMsg(e)); }
  };
  const eliminarCategoria = async (id) => {
    try { await api.delete(`/categorias/${id}`); onChanged(); } catch (e) { toast.error(errorMsg(e)); }
  };

  return (
    <Dialog open={!!tipo} onOpenChange={onClose}>
      <DialogContent className="bg-white">
        <DialogHeader><DialogTitle>Categorías de trabajo</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="flex gap-2">
            <Input data-testid="nueva-categoria-input" placeholder="Nombre de la categoría" value={nuevoCat} onChange={(e) => setNuevoCat(e.target.value)} />
            <Button data-testid="crear-categoria-btn" onClick={crearCategoria} disabled={!nuevoCat.trim()}>Agregar</Button>
          </div>
          <div className="space-y-1 max-h-64 overflow-y-auto">
            {categorias.map((c) => (
              <div key={c.id} className="flex items-center justify-between border border-border rounded-sm px-3 py-1.5 text-sm">
                {c.nombre}
                <Button data-testid={`eliminar-categoria-${c.id}`} variant="ghost" size="icon" className="h-7 w-7 text-destructive" onClick={() => eliminarCategoria(c.id)}><Trash2 size={13} /></Button>
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
